<template>
  <div>
    <vs-popup
      fullscreen
      :title="$t('ContractProducts')"
      :active.sync="showModal"
    >
      <div class="vx-row">
        <div class="vx-col w-full mb-base" v-if="loaded">
          <data-grid
            ref="grid"
            stripe
            :data-source="gridDataSource"
            :search-data="gridSearchData"
            :columns="[
              { title: $t('ProductName'), sort: 'ProductName' },
              { title: $t('WarrantyName'), sort: 'WarrantyName' },
              { title: $t('ColorName'), sort: 'ColorName' },
              { title: $t('ItemCode'), sort: 'ItemCode' },
              { title: $t('ModelNumber'), sort: 'ModelNumber' },
              { title: $t('CalculationType'), sort: 'CalculationType' },
              { title: $t('DiscountAmount'), sort: 'DiscountAmount' },
            ]"
          >
            <template slot-scope="{ row }">
              <td style="width: 25%">{{ row.persianName }}</td>
              <td style="width: 12%">{{ row.warrantyName }}</td>
              <td style="width: 12%">{{ row.colorName }}</td>
              <td style="width: 12%">{{ row.itemCode }}</td>
              <td style="width: 12%">{{ row.modelNumber }}</td>
              <td style="width: 12%">
                <span v-if="row.productDiscountType == '1'">
                  {{ $t("Percent") }}
                </span>
                <span v-if="row.productDiscountType == '2'">
                  {{ $t("quantitative") }}
                </span>
              </td>
              <td style="width: 12%">
                <span v-if="row.productDiscountType == '1'"
                  >{{ row.discountAmount }}درصد</span
                >
                <span v-if="row.productDiscountType == '2'"
                  >{{ Number(row.discountAmount).toLocaleString() }}ریال</span
                >
              </td>
            </template>
          </data-grid>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import DataGrid from "@/components/datagrid/DataGrid";
export default {
  name: "saleManagement_Contract_Management_Festivals_ProductPopup",
  props: {
    show: { default: false },
    model: {
      default: {},
    },
    keywords: {},
  },
  data() {
    return {
      gridDataSource: {},
      gridSearchData: {
        keyword: "",
      },
      loaded: false,
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        this.gridDataSource = {
          type: "app",
          service: "/Promotion/api/Festivals/" + this.model.categoryId,
        };
        this.loaded = true;
        setTimeout(() => {
          this.$refs.grid.renderGrid();
        }, 0);
      }
    },
  },
  components: {
    DataGrid,
  },
};
</script>
